import { defineComponent as _defineComponent } from 'vue'
import { ModalHelper } from '@/helpers/vfm/modal-helper';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { defineAsyncComponent } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyBoxCountrySwitcher',
  props: {
    hideText: { type: Boolean },
    additionalContexts: null
  },
  setup(__props: any) {

const props = __props as { hideText?: boolean; additionalContexts: SnowplowContext[] };

const CountrySwitcherModal = defineAsyncComponent(
	() => import('@/features/buybox/components/CountrySwitcherModal.vue')
);

const { webLocale, countryEmoji } = storeToRefs(useLanguageStore());



const openCountrySwitcherModal = () => {
	ModalHelper.openModal(CountrySwitcherModal, { closable: true });
	TrackingHelper.trackEvent('userinteraction', { action: 'country_selector_clicked' }, props.additionalContexts);
};

return { __sfc: true,CountrySwitcherModal, webLocale, countryEmoji, props, openCountrySwitcherModal, faAngleDown }
}

})